import { render, staticRenderFns } from "./Dataset-Panel.vue?vue&type=template&id=2866cdb8&lang=pug"
import script from "./Dataset-Panel.vue?vue&type=script&setup=true&lang=ts"
export * from "./Dataset-Panel.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports